var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0018 45.818C36.0516 45.818 45.82 36.0497 45.82 23.9998C45.82 11.95 36.0516 2.18164 24.0018 2.18164C11.9519 2.18164 2.18359 11.95 2.18359 23.9998C2.18359 36.0497 11.9519 45.818 24.0018 45.818Z",
    fill: "#1F8342",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0911 30.0709L31.1288 21.002L29.1722 19.0143L22.0911 26.0956L18.6436 22.6481L16.6869 24.6358L22.0911 30.0709ZM23.9755 37.09C22.1884 37.09 20.4941 36.7525 18.8931 36.0774C17.292 35.4024 15.8987 34.4721 14.7134 33.2869C13.528 32.1015 12.5978 30.7082 11.9228 29.1074C11.2477 27.5064 10.9102 25.8102 10.9102 24.019C10.9102 22.2091 11.2483 20.5084 11.9246 18.9169C12.6009 17.3254 13.533 15.9336 14.7211 14.7415C15.9091 13.5494 17.3006 12.6125 18.8956 11.9308C20.4906 11.2491 22.1803 10.9082 23.9648 10.9082C25.7777 10.9082 27.4841 11.2483 29.0845 11.9284C30.6846 12.6085 32.0779 13.5434 33.264 14.733C34.45 15.9226 35.3845 17.3153 36.0674 18.911C36.7505 20.5068 37.092 22.2135 37.092 24.0314C37.092 25.8273 36.7512 27.5203 36.0694 29.1109C35.3875 30.7012 34.4507 32.0904 33.2587 33.2788C32.0666 34.467 30.6748 35.3993 29.083 36.0757C27.4913 36.7518 25.7888 37.09 23.9755 37.09Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.7ebeed3bd195bc563b8f23652d8099eb.svg";
export { ForwardRef as ReactComponent };